import { InjectableClass } from '@fino/lib-injection';

export class ErrorInterceptorProvider {
  constructor() {
    'ngInject';

    this.defaultErrorMessage = null;
  }

  setDefaultErrorMessage(message) {
    this.defaultErrorMessage = message;
  }

  $get($q, errorService) {
    'ngInject';

    const service = new ErrorInterceptorService($q, errorService);

    if (this.defaultErrorMessage !== null) {
      service.defaultErrorMessage = this.defaultErrorMessage;
    }

    return service;
  }
}

class ErrorInterceptorService extends InjectableClass {
  constructor($q, errorService) {
    'ngInject';
    super({ $q, errorService });

    this.requestError = this.requestErrorInternal.bind(this);
    this.responseError = this.responseErrorInternal.bind(this);
    this.response = this.responseInternal.bind(this);
  }

  responseInternal(resp) {
    const { url } = (resp && resp.config) || {};
    const { errorUrl } = this;

    if (url && errorUrl && errorUrl === url) {
      this.errorUrl = null;
      this.errorService.clear();
    }
    return this.$q.resolve(resp);
  }

  requestErrorInternal(config) {
    this.errorService.error(config);
    return this.$q.reject(config);
  }

  responseErrorInternal(resp) {
    if (!resp) {
      resp = {};
    }

    const { config, data, status, statusText } = resp;

    // Ensure the error is not explicitly defined as silent error (which will not be shown!)
    const showError = config && (!config.error || !config.error.silent);
    if (showError) {
      // Save error url to clear error when this request is successful in next try
      this.errorUrl = config.url;

      // Show custom error
      // Or show in provider defined default error message
      // Or show response data
      // Or show response status text
      let error =
        config.error || this.defaultErrorMessage || data || statusText;
      if (!angular.isObject(error)) {
        error = {
          message: error,
          url: config.url,
          status,
        };
      }
      error.requestId = resp.headers('x-request-id');
      error.prefix = error.prefix || 'app.error.response.prefix';
      this.appendStatusIfNecessary(error, resp);
      this.errorService.error(error);
    }

    return this.$q.reject(resp);
  }

  appendStatusIfNecessary(error, resp) {
    // Append status code when defined in error config
    if (
      error &&
      error.status &&
      (error.status === resp.status || error.status.indexOf(resp.status) > -1)
    ) {
      error.message += `.${resp.status}`;
      error.prefix += `.${resp.status}`;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-error-handling/src/error.interceptor.provider.js